export default __webpack_public_path__ + "static/media/main-how-it-works-us-man.ac92ee32.png";